import { Request } from "../../../infrastructure/request";
import { ITracker } from "../../interfaces/tracker.interface";
import { Microservice } from "../../model/microservice";
import { ManifestRepository } from "../../repositories/manifest-repository";
import { BaseChainableBobComponent } from "../base-chainable-bob-component";
import { BaseChainableComponent } from "../pipeline/base-chainable-component";
import { IProcessable } from "../pipeline/processable.interface";

export class ManifestLoaderComponent extends BaseChainableBobComponent<Microservice> implements IProcessable<Microservice> {

	private manifestRepository: ManifestRepository;

	constructor(manifestRepository: ManifestRepository, tracker: ITracker) {

		super(tracker);
		this.manifestRepository = manifestRepository;
	}

	public async process(input: Microservice) {

		input.setManifest(
			await this.manifestRepository.get(new Request(input.marker.url))
		);

		return await this.next.process(input);
	}
}
